import { useGate, useUnit } from 'effector-react'
import {
  $participants,
  $totalCountOfParticipants,
  getParticipantsFx,
  ParticipantListGate,
} from './model'

export const useParticipantList = () => {
  const participants = useUnit($participants)
  const totalCountOfParticipants = useUnit($totalCountOfParticipants)
  const loading = useUnit(getParticipantsFx.pending)

  return {
    participants,
    totalCountOfParticipants,
    loading,
  }
}

export const useParticipantListGate = () => useGate(ParticipantListGate)
